import React from 'react';
import {useDispatch} from 'react-redux';
import parse from 'html-react-parser';

import {Dialog} from 'primereact/dialog';
import {Button} from 'primereact/button';

import {__} from '~/shared/src/utilities/messageCatalog';

import {AppDispatch} from '~/frontend/src/store';
import closePanel from '~/frontend/src/actions/panelManager/closePanel';
import hideConfirmCloseDialog from '~/frontend/src/actions/panelManager/hideConfirmCloseDialog'

const defaultProps = {
    visible: false as boolean
}
type DefaultProps = typeof defaultProps;

type Props = {
    panelKey : string;
    onSaveAndClosePanelAction? : ( dispatch : AppDispatch ) => void | Promise<void>;
};

//type ComponentProps = Partial<DefaultProps> & Props;
type AllProps = DefaultProps & Props;

/**
 * Confirm close dialog
 * @return {JSX.Element}
 * @constructor
 */
const ConfirmCloseDialog = ( props : AllProps ) => {

    const {
              panelKey,
              onSaveAndClosePanelAction,
              visible
          }                      = props,
          dispatch : AppDispatch = useDispatch(),
          footerButtons          = [] as JSX.Element[];

    if ( onSaveAndClosePanelAction ) {
        footerButtons.push( <Button
            key="saveAndCloseButton"
            label={__( 'YN.base.common.saveAndClose' )}
            className="p-button-outlined mr-3"
            onClick={() => dispatch( onSaveAndClosePanelAction )}
        /> );
    }
    footerButtons.push( <Button
        key="closeButton"
        label={__( 'YN.base.common.close' )}
        className="p-button-danger p-button-outlined mr-3"
        onClick={async () => dispatch( closePanel( panelKey ) )}
    /> );
    footerButtons.push( <Button
        key="cancelButton"
        label={__( 'YN.base.common.cancel' )}
        className="p-button-secondary p-button-outlined"
        onClick={() => dispatch( hideConfirmCloseDialog( panelKey ) )}
    /> );

    return <Dialog
        header={__( 'YN.base.panel.confirmClose.title' )}
        footer={<div>
            {footerButtons}
        </div>}
        position="top"
        maskClassName="yn-dialog-panel-modal"
        appendTo="self"
        visible={visible}
        closable={false}
        className="yn-warning-dialog"
        onHide={() => {
        }}
        style={{ width: 'auto', maxWidth: '80%' }}
    >
        <p>{parse( __( 'YN.base.panel.confirmClose.text' ) )}</p>
    </Dialog>;
}

ConfirmCloseDialog.defaultProps = defaultProps;

export default ConfirmCloseDialog;
